import {Grid, MenuItem, Stack, TextField, Typography} from "@mui/material";
import {extensionLabel} from "../../hooks/useAmiExtensions";

const extensionHelper = (selected, {loading, error, extensions}) => {
  if (loading) return "Loading extensions...";
  if (error) return "Failed to load extensions";
  if (extensions.length === 0) return "No extensions yet - add one on the SIP Dialplan page";
  if (selected) return `Trunk: ${selected.trunk || "default"} · Context: ${selected.context || "default"}`;
  return "Voice bot extension answered calls go to";
};

// Where outbound calls come from and which extension answered calls are sent to
export const CampaignCallFields = ({form, setField, amiExtensions}) => {
  const {extensions, loading, error, getExtension} = amiExtensions;
  const selected = getExtension(form.extensionId);
  // Keep a saved extension that no longer exists visible instead of showing an empty select
  const missing = form.extensionId && !selected && !loading;

  return (
    <>
      <Grid item xs={12} md={4}>
        <TextField
          label="From number" fullWidth required size="small"
          placeholder="e.g. 38923111000"
          value={form.fromNumber} onChange={setField("fromNumber")}
          helperText="Caller ID the called person sees"
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <TextField
          select label="Extension" fullWidth required size="small"
          value={loading && form.extensionId && !selected ? "" : form.extensionId}
          onChange={setField("extensionId")}
          disabled={loading}
          SelectProps={{renderValue: (value) => extensionLabel(getExtension(value)) || "Unknown extension"}}
          error={error || !!missing}
          helperText={missing ? "The selected extension no longer exists - choose another one" : extensionHelper(selected, amiExtensions)}
        >
          {missing && <MenuItem value={form.extensionId} disabled>Unknown extension</MenuItem>}
          {extensions.map(ext => (
            <MenuItem key={ext.id || ext.extension} value={String(ext.id)} disabled={!ext.id}>
              <Stack>
                <Typography fontSize={14}>{extensionLabel(ext)}</Typography>
                {ext.description &&
                  <Typography fontSize={12} color="text.secondary">{ext.description}</Typography>
                }
              </Stack>
            </MenuItem>
          ))}
        </TextField>
      </Grid>
    </>
  )
}
